import { request } from "./client";
import { registerMessages } from "./errors";

registerMessages({
  "failed to list gym duties": "Не удалось загрузить дежурства",
  "failed to create gym duty": "Не удалось добавить дежурство",
  "failed to delete gym duty": "Не удалось удалить дежурство",
});

// assigned_by is "coach" when a coach or the admin put the child on duty and
// "player" when the child took a free slot in the app; null for a free slot.
export interface GymDuty {
  id: string;
  date: string;
  group_id: string | null;
  player_id: string | null;
  note: string | null;
  assigned_by: "coach" | "player" | null;
  created_at: string;
}

export interface GymDutyInput {
  date: string;
  group_id: string;
  player_id: string | null;
  note: string | null;
}

export const gymDutiesApi = {
  // month is "2026-09"; without it the server returns every date.
  list: (groupID: string, month?: string) => {
    const params = new URLSearchParams({ group_id: groupID });
    if (month) params.set("month", month);
    return request<GymDuty[] | null>(`/api/gym-duties/?${params}`);
  },

  // The server pushes a notification to the child when player_id is set.
  create: (input: GymDutyInput) =>
    request<GymDuty>("/api/gym-duties/", { method: "POST", body: JSON.stringify(input) }),

  remove: (id: string) =>
    request<void>(`/api/gym-duties/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
